module.exports = __webpack_public_path__ + "img/sign_warning.d9112547.svg";